module.exports = __webpack_public_path__ + "static/media/rita_de_cassia_mendonca_sales_contini.c6289fa1.jpg";